"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultStoreState = exports.reducer = void 0;
const redux_1 = require("redux");
const questions_1 = __importDefault(require("./questions"));
const pages_1 = __importStar(require("./pages"));
const screenouts_1 = __importDefault(require("./screenouts"));
const survey_1 = __importStar(require("./survey"));
const groups_1 = __importDefault(require("./groups"));
const widgets_1 = __importDefault(require("./widgets"));
const lang_1 = __importDefault(require("./lang"));
const location_1 = __importDefault(require("./location"));
const conditions_1 = __importDefault(require("./conditions"));
const config_1 = __importDefault(require("./config"));
const notifications_1 = __importDefault(require("./notifications"));
const theme_mode_1 = __importDefault(require("./theme_mode"));
const dims_1 = __importStar(require("./dims"));
exports.reducer = (0, redux_1.combineReducers)({
    location: location_1.default,
    pages: pages_1.default,
    screenouts: screenouts_1.default,
    questions: questions_1.default,
    widgets: widgets_1.default,
    survey: survey_1.default,
    groups: groups_1.default,
    lang: lang_1.default,
    conditions: conditions_1.default,
    config: config_1.default,
    notifications: notifications_1.default,
    themeMode: theme_mode_1.default,
    dims: dims_1.default
});
const getDefaultStoreState = (loc) => {
    return {
        location: loc,
        pages: pages_1.PAGES_INIT_STATE,
        screenouts: {},
        questions: {},
        widgets: {},
        survey: survey_1.SURVEY_INIT_STATE,
        groups: {},
        lang: 'ru',
        conditions: {},
        config: {},
        notifications: null,
        themeMode: 'system',
        dims: dims_1.DIMS_INIT_STATE
    };
};
exports.getDefaultStoreState = getDefaultStoreState;
